import { DesktopDatePicker } from "@mui/lab";
import { TextField } from "@mui/material";
import moment from "moment";
import { FieldError } from "types";
import { FieldContainer } from "./commonFieldStyles";

type Props = {
  id: string;
  label: string;
  value: string | null;
  onChange(value: string): void;
  required: boolean | undefined;
  errObj?: FieldError | undefined;
  disabled: boolean | undefined;
  disableFutureDates?: boolean;
  disablePastDates?: boolean;
  minDate?: moment.Moment;
  customStyle?: React.CSSProperties;
};

export default function DateFieldNonFieldEditor(props: Props) {
  return (
    <DesktopDatePicker
      label={props.label}
      value={props.value}
      disabled={props.disabled}
      onChange={(newValue) =>
        props.onChange(moment(newValue).format("MM/DD/YYYY").toString())
      }
      disableFuture={props.disableFutureDates ?? false}
      disablePast={props.disablePastDates ?? false}
      minDate={props.minDate ?? undefined}
      renderInput={(params) => (
        <FieldContainer>
          <TextField
            {...params}
            id={props.id}
            variant="filled"
            fullWidth
            required={props.required}
            error={!!props.errObj}
            helperText={!!props.errObj && props.errObj.error}
            size="small"
            style={props.customStyle}
          />
        </FieldContainer>
      )}
    />
  );
}
